module.exports = __webpack_public_path__ + "img/logo-bienvenida.3cef3688.png";